import { t } from 'i18next';

export function getLinkSupport(): string {
  const message = encodeURIComponent(t('mensagemSuporteWhatsapp'));
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  return isMobile
    ? `https://api.whatsapp.com/send?phone=${process.env.REACT_APP_SUPPORT_NUMBER}&text=${message}`
    : `https://web.whatsapp.com/send?phone=${process.env.REACT_APP_SUPPORT_NUMBER}&text=${message}`;
}
